import {create} from 'zustand';

interface ProgressState {
  progress: number;
}

interface ProgressStore extends ProgressState {
  setProgress: (percent: number) => void;
  resetState: () => void;
}

const INITIAL_STATE: ProgressState = {
  progress: 0,
};

export const useProgressStore = create<ProgressStore>(set => ({
  ...INITIAL_STATE,
  setProgress: percent => set({progress: percent}),
  resetState: () => set(INITIAL_STATE),
}));
